import { render } from "./BancheECodiciConto.vue?vue&type=template&id=8444dc60"
import script from "./BancheECodiciConto.vue?vue&type=script&lang=js"
export * from "./BancheECodiciConto.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__